import { BaseService } from '@/lib/baseService'
import type { LoginResponse } from '@/types/auth';

export class CheckAuthService
  extends BaseService {
  constructor() {
    super('/v1/account');
  }

  async isAuthenticated(): Promise<LoginResponse | null> {
    try {
      const res = await this.apiClient.get('/is-authenticated');
      return res.data;
    } catch {
      return null;
    }
  }
}